import React from 'react';
import { Share2, Facebook, Twitter, Linkedin } from 'lucide-react';
import { cn } from '../utils/cn';

type ShareButtonsProps = {
  className?: string;
};

export function ShareButtons({ className }: ShareButtonsProps) {
  const shareText = "Check out this new app. It's helping me jump to freedom and success and I thought you would like it.";
  const shareUrl = "https://www.freelie.net";
  const shareImage = "https://storage.googleapis.com/msgsndr/uyhOpumyT9PNneWXZAK1/media/685dd3955c72d2a4952fb566.png";
  
  const platforms = [
    {
      name: 'Facebook',
      icon: Facebook,
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}&quote=${encodeURIComponent(shareText)}&picture=${encodeURIComponent(shareImage)}`,
      color: 'bg-blue-600 hover:bg-blue-700'
    },
    {
      name: 'X / Twitter',
      icon: Twitter,
      url: `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(shareUrl)}`,
      color: 'bg-black hover:bg-gray-800'
    },
    {
      name: 'LinkedIn',
      icon: Linkedin,
      url: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}&summary=${encodeURIComponent(shareText)}`,
      color: 'bg-blue-700 hover:bg-blue-800'
    },
    {
      name: 'Copy Link',
      icon: Share2,
      action: () => {
        navigator.clipboard.writeText(`${shareText} ${shareUrl}`);
        alert('Link copied to clipboard!');
      },
      color: 'bg-gray-600 hover:bg-gray-700'
    }
  ];

  return (
    <div className={cn("space-y-4", className)}>
      <h3 className="text-lg font-medium text-gray-700 mb-2">Share with friends</h3>
      <p className="text-sm text-gray-600 mb-4">
        Know someone who could benefit from this app? Share it with them!
      </p>
      <div className="grid grid-cols-2 gap-3">
        {platforms.map((platform) => (
          <button
            key={platform.name}
            onClick={() => platform.action ? platform.action() : window.open(platform.url, '_blank')}
            className={cn(
              "flex items-center justify-center gap-2 px-4 py-2 rounded-lg text-white transition-colors",
              platform.color
            )}
          >
            <platform.icon className="w-4 h-4" />
            <span>{platform.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
}